import type { ReactNode } from 'react'

import { Container } from './Container'
import { Content } from './Content'
import { Count } from './Count'
import { Header } from './Header'
import { Line } from './Line'

type Props = {
	step: boolean
	title: ReactNode
	children: ReactNode
}

export const Step = ({ step, title, children }: Props) => (
	<Container>
		<Header>
			<Line />
			<Count>{step}</Count>
			<span>{title}</span>
		</Header>
		<Content>{children}</Content>
	</Container>
)
